<template>
  <!--
    Komponent wyświetlający legendę statusów.
    Używany wewnątrz filtrów do objaśnienia ikon dostępności.
  -->
  <div class="filter d-flex flex-column">
    <!-- Nagłówek sekcji legendy -->
    <h5>
      {{ t('legend') }}  <!-- Tytuł legendy (przetłumaczony) -->
    </h5>

    <!-- Kontener z pozycjami legendy.
         Wiersze układamy flexboxem (a nie siatką Bootstrapa), bo w węższym
         sidebarze kolumny `col-*` nie dawały ikonie własnej szerokości
         i opis nachodził na ikonę. -->
    <div class="info collapse show" id="legend">
      <!-- Wiersz z ikoną OK i opisem -->
      <div class="legend-row">
        <span class="legend-row__icon icons-status-ok"></span>
        <span class="legend-row__label">{{ t('available') }}</span>
      </div>
      <!-- Wiersz z ikoną NOT OK i opisem -->
      <div class="legend-row">
        <span class="legend-row__icon icons-status-not-ok"></span>
        <span class="legend-row__label">{{ t('unavailable') }}</span>
      </div>
      <!-- Przykładowe dodatkowe wiersze (zakomentowane) -->
      <!-- <div class="row mb-2">
        <div class="col-1"></div>
        <div class="col-2 icons-status-error"></div>
        <div class="col-7 p-0">Awaria</div>
      </div>
      <div class="row mb-2">
        <div class="col-1"></div>
        <div class="col-2 icons-status-on"></div>
        <div class="col-7 p-0">Włączony</div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
/**
 * Korzystamy z vue-i18n do tłumaczeń tekstów.
 */
import { useI18n } from 'vue-i18n';
const { t } = useI18n();  // Funkcja tłumacząca klucze
</script>

<style scoped>
/* Styl nagłówka sekcji */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Wiersz legendy: ikona statusu + opis, wyrównane w jednej linii bazowej. */
.legend-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  min-width: 0;
}

.legend-row + .legend-row {
  margin-top: var(--spacing-sm);
}

.legend-row__icon {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.legend-row__label {
  min-width: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

/* Kontener z wpisami legendy */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--border-default);  /* Dolna ramka */
}

/* Dodatkowe style dla paragrafów wewnątrz info (jeśli użyte) */
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
}
</style>
